export function initialTasks(definition) {
    return Object.fromEntries((definition.tasks ?? []).map((task) => [task.id, initialTaskState()]));
}
export function initialTaskState() {
    return { nextSequence: 0n, queue: [], active: null, completed: [], refunds: [] };
}
export function initialCalendars(definition) {
    return Object.fromEntries((definition.calendars ?? []).map((calendar) => [
        calendar.id,
        { phaseIndex: 0, elapsedMs: 0, cycle: 0n, boundaries: [] },
    ]));
}
export function initialMarkets(definition) {
    const zero = definition.numbers?.fromNumber(0);
    if (zero === undefined)
        throw new TypeError("Game definition has no numeric adapter");
    return Object.fromEntries((definition.markets ?? []).map((market) => [market.id, { bought: zero, sold: zero }]));
}
export function cloneTasks(source) {
    return Object.fromEntries(Object.entries(source).map(([id, state]) => [
        id,
        {
            ...state,
            queue: state.queue.map((entry) => ({
                ...entry,
                escrow: { ...entry.escrow },
                outputs: { ...entry.outputs },
            })),
            active: state.active
                ? {
                    ...state.active,
                    escrow: { ...state.active.escrow },
                    outputs: { ...state.active.outputs },
                }
                : null,
            completed: state.completed.map((claim) => ({
                ...claim,
                quantities: { ...claim.quantities },
            })),
            refunds: state.refunds.map((claim) => ({ ...claim, quantities: { ...claim.quantities } })),
        },
    ]));
}
export function freezeTasks(source) {
    return Object.freeze(Object.fromEntries(Object.entries(source).map(([id, state]) => [id, freezeTask(state)])));
}
function freezeTask(state) {
    const claims = (values) => Object.freeze(values.map((claim) => Object.freeze({ ...claim, quantities: Object.freeze(claim.quantities) })));
    return Object.freeze({
        ...state,
        queue: Object.freeze(state.queue.map((entry) => Object.freeze({
            ...entry,
            escrow: Object.freeze(entry.escrow),
            outputs: Object.freeze(entry.outputs),
        }))),
        active: state.active
            ? Object.freeze({
                ...state.active,
                escrow: Object.freeze(state.active.escrow),
                outputs: Object.freeze(state.active.outputs),
            })
            : null,
        completed: claims(state.completed),
        refunds: claims(state.refunds),
    });
}
export function cloneCalendars(source) {
    return Object.fromEntries(Object.entries(source).map(([id, state]) => [
        id,
        { ...state, boundaries: state.boundaries.map((entry) => ({ ...entry })) },
    ]));
}
export function freezeCalendars(source) {
    return Object.freeze(Object.fromEntries(Object.entries(source).map(([id, state]) => [
        id,
        Object.freeze({
            ...state,
            boundaries: Object.freeze(state.boundaries.map((entry) => Object.freeze({ ...entry }))),
        }),
    ])));
}
export function freezeMarkets(source) {
    return Object.freeze(Object.fromEntries(Object.entries(source).map(([id, state]) => [id, Object.freeze({ ...state })])));
}
//# sourceMappingURL=timed-state.js.map